module.exports = __webpack_public_path__ + "img/user7.d1ef5b9b.png";